export const ICONS_PATH = '/client/shared/images/icons/misc/';
export const SUCCESS_ICON = 'receipt-success-animation.svg';
export const SUCCESS_ICON_MRG = 'receipt-success-animation-mrg.svg';
